import REPORT from './Report';

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/VoiceCdr/components/index.js